<template>
    <div class="uploadfile">
        <el-button v-if="!disableEdit" class="upload-btn" size="mini" block @click="onUploadClick" :disabled="disableUploadBtn">
            <img :src="UploadIcon" />
            <input type="file" class="files" style="display: none" ref="file" multiple="multiple" @change="onFileChange" />
            {{ $t('ita_choose_files') }}
        </el-button>
        <div class="tip" v-if="!disableEdit">{{ $t('ita_upload_tip') }}</div>
        <div class="files">
            <div class="file-item" v-for="(v, k) in hereValue" :key="k">
                <div
                    :class="[v.status == 'success' ? 'filename-success' : 'filename']"
                    @click="() => (canDownload(v) ? onDownloadClick(v) : () => {})"
                >
                    {{ v.fileName }}
                </div>
                <div class="btns">
                    <!-- 下载按钮 -->
                    <i class="btn el-icon-download" v-show="canDownload(v) && !v.downloadLoading" @click="onDownloadClick(v)"></i>
                    <i class="btn el-icon-loading" v-show="v.status == 'success' && v.downloadLoading"></i>

                    <!-- 状态图标 -->
                    <i class="btn el-icon-circle-check" v-show="v.status == 'success'"></i>
                    <i class="btn el-icon-loading" v-show="v.status == 'uploading'"></i>
                    <i class="btn el-icon-warning" v-show="v.status == 'failed'"></i>

                    <!-- 删除按钮 -->
                    <i class="btn el-icon-delete" v-show="v.status != 'uploading' && !disableEdit" @click="onDeleteClick(k)"></i>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import UploadIcon from '@/assets/img/icon-upload.svg'
import { mapGetters } from 'vuex'
import API from '@/api'
import { isIE } from '@/utils'
import { checkIsValidExtension } from '@/utils/fileType'
import { userPermission } from '@/mixins/userPermission.js'
import { downloadSingleFile } from '@/utils/useDownload'

export default {
    name: 'UploadFile',
    mixins: [userPermission],
    data() {
        return {
            UploadIcon,
            hereValue: []
        }
    },
    props: {
        value: {
            type: Array,
            default: () => []
        },
        onChange: {
            type: Function,
            default: () => {}
        },
        disableEdit: {
            type: Boolean,
            default: false
        },
        currentSummaryId: {
            type: String,
            default: ''
        }
    },
    mounted() {
        this.hereValue = this.value ? this.value : []
    },
    methods: {
        canDownload(v) {
            return v.status == 'success' && this.hasPermission('download')
        },
        onDownloadClick(v) {
            const fileId = v.fileId

            const paramsdata = {
                siteId: this.getSite.siteId,
                fileId,
                source: 'ita'
            }
            downloadSingleFile(paramsdata)
        },
        onDeleteClick(k) {
            const v = this.hereValue[k]
            if (v.status == 'success') {
                API.exchange.deleteFile({ id: v.fileId }).then((res) => {
                    if (res.code == '1') {
                        this.hereValue.splice(k, 1)
                    } else {
                        this.$message.error(this.$t(res.code))
                    }
                })
            } else {
                this.hereValue.splice(k, 1)
            }
        },
        onFileChange() {
            let fileAlert = false
            const newFiles = [...this.$refs.file.files]
                .filter((v) => {
                    if (!checkIsValidExtension(v.name)) {
                        fileAlert = true
                        return false
                    }
                    const isLt100M = v.size / 1024 / 1024 < 100
                    if (!isLt100M) {
                        fileAlert = true
                        return false
                    }

                    return true
                })
                .map((v) => ({
                    fileName: v.name,
                    fileSize: v.size,
                    fileType: v.type,
                    status: 'uploading',
                    file: v
                }))
            this.hereValue = [...this.hereValue, ...newFiles]
            if (this.hereValue.length > 100) {
                fileAlert = true
            }

            if (fileAlert) {
                this.$message.warning(this.$t('ita_upload_tip'))
            }
            this.hereValue = this.hereValue.filter((v, k) => k <= 99)
            Promise.all(
                newFiles.map((v) => {
                    const formData = new FormData()
                    formData.append('source', 'itu')
                    formData.append('fileName', v.fileName)
                    formData.append('siteId', this.getSite.siteId)
                    formData.append('file', v.file)
                    formData.append('id', v.id)
                    formData.append('summaryId', this.currentSummaryId)

                    return API.exchange
                        .uploadItuFiles(formData)
                        .then((res) => {
                            if (res.code == '1') {
                                v.status = 'success'
                                v.fileId = res.data.uploadDocumentInfo.id
                            } else {
                                this.$message.error(this.$t(res.code))
                                v.status = 'failed'
                            }
                        })
                        .catch((e) => {
                            this.$message.error(this.$t('file_upload_failed'))
                        })
                })
            ).finally(() => {
                this.hereValue = this.hereValue.filter((v) => v.status != 'failed')
                this.onChange && this.onChange(this.hereValue)
            })
        },
        onUploadClick() {
            this.$refs.file.click()
        }
    },
    computed: {
        disableUploadBtn() {
            if (!this.hereValue) {
                this.hereValue = []
            }
            return !this.hereValue.every((v) => v.status == 'success')
        },
        ...mapGetters('common', {
            getSite: 'getSite',
            getUser: 'getUser',
            getEntityIds: 'getEntityIds'
        })
    },
    watch: {
        hereValue(v) {
            this.$emit('update:value', v)
            this.onChange && this.onChange(v)
        },
        value(v) {
            this.hereValue = v ? v : []
        }
    }
}
</script>
<style scoped>
.uploadfile {
    display: flex;
    flex-direction: column;
}
::v-deep .el-button,
::v-deep .el-button:hover,
::v-deep .el-button:active,
::v-deep .el-button:focus {
    color: white;
    background-color: #3879eb;
    border: none;
}
::v-deep .el-button span {
    display: flex;
    flex-direction: row;
    align-items: center;
}
::v-deep .el-button span img {
    margin-right: 10px;
}
.uploadfile .upload-btn {
    width: 120px;
    display: flex;
    flex-direction: row;
    justify-content: center;
}
.uploadfile .tip {
    font-size: 10px;
    color: #bcbfc1;
    margin-top: 5px;
}
.uploadfile .files {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 20px;
}
.uploadfile .files .file-item {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
}
.uploadfile .files .file-item .filename {
    font-size: 14px;
    color: #1a1a1a;
}
.uploadfile .files .file-item .filename-success {
    color: #548bed;
    text-decoration: underline;
    cursor: pointer;
}
.uploadfile .files .file-item .btns {
    display: flex;
    flex-direction: row;
    align-items: center;
}
.uploadfile .files .file-item .btns .btn {
    font-size: 18px;
    margin-left: 10px;
    cursor: pointer;
}
.uploadfile .files .file-item .btns .el-icon-download {
    color: #6194ef;
}
.uploadfile .files .file-item .btns .el-icon-circle-check {
    color: #26a85f;
}
.uploadfile .files .file-item .btns .el-icon-loading {
    color: #5fb7ff;
}
.uploadfile .files .file-item .btns .el-icon-warning {
    color: #e74c2d;
}
.uploadfile .files .file-item .btns .el-icon-delete {
    color: #fd349c;
}
</style>
